var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-tooltip"},[(_vm.show)?_c('div',{staticClass:"c-tooltip__tip"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.show = !_vm.show}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }